import { useState, useCallback } from 'react';

export interface OnboardingState {
  isVisible: boolean;
  accountVerified: boolean;
  stripeConnected: boolean;
  businessProfileCompleted: boolean;
  hasCreatedProduct: boolean;
  hasCreatedBundle: boolean;
  hasSharedLink: boolean;
  setupCompleted: boolean;
  showCompletionConfirmation: boolean;
}

export const ONBOARDING_STORAGE_KEY = 'keepmore_onboarding_state';

export const useOnboardingState = () => {
  const [state, setState] = useState<OnboardingState>({
    isVisible: true,
    accountVerified: false,
    stripeConnected: false,
    businessProfileCompleted: false,
    hasCreatedProduct: false,
    hasCreatedBundle: false,
    hasSharedLink: false,
    setupCompleted: false,
    showCompletionConfirmation: false,
  });

  const [userId, setUserId] = useState<string | null>(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const [hasInitialized, setHasInitialized] = useState(false);

  const saveOnboardingState = useCallback((newState: Partial<OnboardingState>) => {
    if (!userId) return;
    
    const updatedState = { ...state, ...newState };
    setState(updatedState);
    localStorage.setItem(`${ONBOARDING_STORAGE_KEY}_${userId}`, JSON.stringify(updatedState));
  }, [state, userId]);

  const updateState = useCallback((newState: Partial<OnboardingState>) => {
    setState(prev => ({ ...prev, ...newState }));
  }, []);

  return {
    state,
    setState,
    userId,
    setUserId,
    isInitialized,
    setIsInitialized,
    hasInitialized,
    setHasInitialized,
    saveOnboardingState,
    updateState
  };
};
